import PropTypes from 'prop-types';
import { motion } from "framer-motion";
import { Magnet } from 'lucide-react';
import {
    slideAnimation2,
    slideAnimation4
} from "../../../../components/HomeBackground/systems/constants.js";
import {
    IconAddSVG, IconAddText, IconBaseLayout, IconHole, IconColor
} from "./Icons.jsx";
import DropdownAddShape from "./DropdownAddShape.jsx";
import {
    useEditorTypeRightContext, useEditorTypeRightToggleContext,
    useSelectedTypeContext, useSelectedTypeToggleContext
} from "../../SelectedTypeProvider.jsx";
function ToolSelectorTop({
    toggleContentVisibility,
    onEnter3d,
    hasPending3dChanges = false,
    isRegenerating3d = false,
    regenerationPhase = null,
    product = null,
}) {
    const selectedType = useSelectedTypeContext();
    const setSelectedType = useSelectedTypeToggleContext();

    const editorTypeRight = useEditorTypeRightContext();
    const setEditorTypeRight = useEditorTypeRightToggleContext();

    const handleButtonClick = (type) => {
        if (type === "3D") {
            if (selectedType === '3D') return
            // onEnter3d cambia la vista a 3D de inmediato y gestiona el estado
            // de generación/carga dentro de la propia escena 3D. Si ya hay una
            // generación en marcha se limita a enseñarla: volver a 3D mientras
            // carga es justo lo que se quiere poder hacer, y quien decide si
            // toca regenerar o no es el Customizer, que es quien lo sabe.
            onEnter3d()
        } else {
            setEditorTypeRight({ ...editorTypeRight, type: null });
            setSelectedType(type);
        }
    };
    const handleToolRight = (type) => {
        // setEditorTypeRight(type);
        setEditorTypeRight({ ... editorTypeRight, type: type})
    }

    const slideAnimation8 = {
        initial: { y: -100 },
        animate: { y: 0 },
        exit: { y: -100 },
        transition: { duration: 0.3 }
    };

    return (
        <motion.div {...slideAnimation8} className="mx-auto mt-3 editortabs-container fixed top-0 p-0 max-w-[calc(100%-160px)]">
            <motion.div {...slideAnimation4()} className="z-50 relative min-w-full flex">
                <motion.span
                    className={`p-3 flex items-center justify-center cursor-pointer w-fit ${selectedType === "2D" ? 'selected' : 'not-selected'}`}
                    onClick={() => handleButtonClick("2D")}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                >
                    2D
                </motion.span>
                <div className="w-full min-w-36 items-center justify-center">
                    {selectedType === "2D" && (
                        <div className="flex p-1 gap-1">
                            <motion.span {...slideAnimation2()}>
                                <button
                                    className="btnMod tooltip tooltip-bottom"
                                    data-tip="Cambiar diseño de fondo"
                                    title="Cambiar base layout"
                                    onClick={() => handleToolRight("editor_base_layout")}
                                >
                                    <IconBaseLayout />
                                </button>
                            </motion.span>
                            <motion.span {...slideAnimation2()}>
                                <button
                                    className="btnMod tooltip tooltip-bottom"
                                    data-tip="Añadir texto al diseño"
                                    title="Añadir texto"
                                    onClick={() => {
                                        setEditorTypeRight({
                                            ...editorTypeRight,
                                            data: {
                                                is_new: true,
                                                font: "Abril Fatface",
                                                fontStyle: 'normal',
                                                fontWeight: 'normal',
                                                text: '',
                                            },
                                            type: "editor_text"
                                        });
                                    }}
                                >
                                    <IconAddText className="w-10 h-10" />
                                </button>
                            </motion.span>
                            <motion.span {...slideAnimation2()}>
                                <DropdownAddShape
                                    className="btnMod tooltip tooltip-bottom"
                                    data-tip="Añadir forma SVG"
                                    title="Añadir forma"
                                />
                            </motion.span>
                            <motion.span {...slideAnimation2()}>
                                <button
                                    className="btnMod tooltip tooltip-bottom"
                                    data-tip="Insertar un medio SVG"
                                    title="Añadir Medio"
                                    onClick={toggleContentVisibility}
                                >
                                    <IconAddSVG className="w-10 h-10" />
                                </button>
                            </motion.span>
                            <motion.span {...slideAnimation2()}>
                                <button
                                    className="btnMod tooltip tooltip-bottom"
                                    data-tip={product?.holeTool?.tooltip ?? "Modificar el agujero en el diseño"}
                                    title={product?.holeTool?.title ?? "Modificar agujero"}
                                    onClick={() => handleToolRight("editor_hole")}
                                >
                                    {product?.roles?.internalElements
                                        ? <Magnet className="w-9 h-9" />
                                        : <IconHole className="w-10 h-10" />}
                                </button>
                            </motion.span>
                            <motion.span {...slideAnimation2()}>
                                <button
                                    className="btnMod tooltip tooltip-bottom"
                                    data-tip="Cambiar colores de los objetos"
                                    title="Modificar colores"
                                    onClick={() => handleToolRight("editor_color")}
                                >
                                    <IconColor className="w-10 h-10" />
                                </button>
                            </motion.span>
                        </div>
                    )}
                    {selectedType === "3D" && (
                        <div className="flex h-full flex-col items-center justify-center px-4">
                            {/* El estado del 3D vive aquí, en el único sitio de
                                la interfaz donde ya se contaba si el modelo
                                está al día. Antes la regeneración se anunciaba
                                además con un cartel sobre la escena, que caía
                                justo debajo de esta barra y se solapaba. */}
                            {regenerationPhase ? (
                                <div className="flex w-full max-w-xs flex-col gap-1">
                                    <span className="text-xs font-medium">
                                        {regenerationPhase === 'generating'
                                            ? 'Generando archivo 3D…'
                                            : 'Cargando modelo 3D…'}
                                    </span>
                                    {/* Sin value: el backend no reporta avance,
                                        así que la barra es indeterminada en vez
                                        de fingir un porcentaje. */}
                                    <progress className="progress progress-primary h-1.5 w-full" />
                                </div>
                            ) : (
                                <div className={`badge gap-2 ${hasPending3dChanges ? 'badge-warning' : 'badge-success'}`}>
                                    {hasPending3dChanges ? 'Cambios 3D pendientes' : 'Modelo 3D actualizado'}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <motion.span
                    className={`p-3 flex items-center justify-center cursor-pointer w-fit ${selectedType === "3D" ? 'selected' : 'not-selected'}`}
                    onClick={() => handleButtonClick("3D")}
                    aria-disabled={isRegenerating3d}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    {(isRegenerating3d && selectedType !== '3D') ? (
                        <span className="flex items-center gap-2">
                            <span className="loading loading-spinner loading-xs" />
                            Generando
                        </span>
                    ) : '3D'}
                </motion.span>
            </motion.div>
        </motion.div>
    );
}

ToolSelectorTop.propTypes = {
    toggleContentVisibility: PropTypes.func.isRequired,
    onEnter3d: PropTypes.func.isRequired,
    hasPending3dChanges: PropTypes.bool,
    isRegenerating3d: PropTypes.bool,
    regenerationPhase: PropTypes.oneOf(['generating', 'loading']),
    product: PropTypes.object,
}

export default ToolSelectorTop;
